import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LiveData } from './features/live-data/live-data';
import { HistoricalData } from './features/historical-data/historical-data';
import { Alarms } from './features/alarms/alarms';
import { XgsGuard } from './auth/auth-guards/xgs-guard.guard';

const routes: Routes = [
  { path: '', redirectTo: 'live-data', pathMatch: 'full' },
  { path: 'live-data', component: LiveData, canActivate: [XgsGuard] },
  { path: 'historical-data', component: HistoricalData, canActivate: [XgsGuard] },
  { path: 'alarms', component: Alarms, canActivate: [XgsGuard] },
  {
    path: 'user',
    loadChildren: () => import('./user-management/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'role',
    loadChildren: () => import('./user-management/role/role.module').then(m => m.RoleModule)
  },
  { path: '**', redirectTo: 'live-data' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
